module.exports = "<!-- <h1>INSA Job Log</h1> -->\r\n<div class=\"wide-grid\">\r\n  <generic-grid [metadataName]=\"jobLogName\"></generic-grid>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-cron/insa-job-log/insa-job-log.component.html
// module id = 1748
// module chunks = 2